/* eslint no-console: off */

import '@polymer/iron-pages/iron-pages.js';
import * as Async from '@polymer/polymer/lib/utils/async.js';

(function () {
    /*
        This is a hack to add a selected-attribute-value attribute to the iron-pages functionality.
        This will allow the selected-attribute value to be set specifically to a certain bound value
        rather than just a bool. This is particularly useful to have the subroute data set only when
        the page is actually selected.

        ADDITION: At the bottom of _applySelection a new custom addition has been made that fires
        a 'selected'/'deselected' event to the selected item (ie view).

        This is based off of: https://github.com/PolymerElements/iron-selector/pull/148/
    */
    let ELE = customElements.get('iron-pages');
    if (ELE && ELE.prototype) ELE = ELE.prototype;
    else {
        console.log('IronPages Hack Failed');
        return;
    }

    ELE.properties.selectedAttributeValue = {
        type: Object,
        value: null
    };

    ELE.observers.push('_updateAttributeValue(selectedItem, selectedAttribute, selectedAttributeValue, selectedAttributeValue.*)');

    ELE._updateAttributeValue = function (selectedItem, selectedAttribute, selectedAttributeValue, selectedAttributeValueChangeRecord) {
        if (selectedItem && selectedAttribute) {
            // If both selectedItem and selectedAttributeValue are changed (ie the whole route is changed)
            // then an issue can occure where this observer is triggered when only selectedAttributeValue has
            // been set but the current/old selectedItem has not been updated according to the new route.
            // So...
            // Aync this code so execution is after any other property updates that are occuring at the
            // same time (ie selectedItem), that way the selectedAttributeValue will be applied to the
            // appropriate selectedItem (rather than the 'old' one).
            Async.microTask.run(_ => {
                // Use this.selectedItem so we get the updated selectedItem rather than the old one
                // that would have been provided in the original observer call (closure).

                // If element is being created then set function wont be initialized yet, just set the value.
                // Otherwise use set function which is particularly important if a sub-prop is being changed.
                this.selectedItem[this.selectedAttribute] = selectedAttributeValue;

                if (this.selectedItem.notifyPath) {
                    const path = selectedAttributeValueChangeRecord.path.replace('selectedAttributeValue', selectedAttribute);
                    this.selectedItem.notifyPath(path);
                }
            });
        }
    };

    ELE._applySelection = function (item, isSelected) {
        if (this.selectedClass) {
            this.toggleClass(this.selectedClass, isSelected, item);
        }
        if (this.selectedAttribute) {
            if (this.selectedAttributeValue) {
                item[this.selectedAttribute] = isSelected ? this.selectedAttributeValue : null;
            }
            else {
                this.toggleAttribute(this.selectedAttribute, isSelected, item);
            }
        }
        this._selectionChange();
        this.fire(`iron-${isSelected ? 'select' : 'deselect'}`, { item: item });

        // CUSTOM ADDITION: If we ever decide to remove the IronPages hack (eg it gets fixed)
        // we will need to retain this event dispatch functionality so items know when they are selected.
        item.dispatchEvent(new Event(isSelected ? 'selected' : 'deselected'));
    };
})();